import { Contract, ContractDetails, FinancialDetails, ProductTypeEN, isVDLContract } from 'cpfr-common';
import { useMyProfile } from 'components/my-profile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollectionDateSection } from './collection-date-section';
import { GeneralSection } from './general-section';
import { IbanSection } from './iban-section';
import { PaymentSection } from './payment-section';
import { Accordion } from '@vwfs-bronson/bronson-react';

type FinancialDetailsProps = {
    contract?: Contract & ContractDetails;
    financialDetails?: FinancialDetails;
    isContactInformationChangePending: boolean;
    setShowSuccessNotification: (val: boolean) => void;
};

export const FinancialDetailsComponent: React.FC<FinancialDetailsProps> = ({
    contract,
    financialDetails,
    isContactInformationChangePending,
    setShowSuccessNotification,
}) => {
    const { t } = useTranslation('financial-details');
    const { data: myProfileData } = useMyProfile();
    if (
        !financialDetails ||
        !contract ||
        (contract.productTypeEN === ProductTypeEN.STAND_ALONE && contract.productType)
    ) {
        return null;
    }

    const { isActive, productType, productTypeEN, contractId } = contract;

    const isSMECustomer = myProfileData?.identification?.customerType
        ? myProfileData?.identification?.customerType !== 'Retail'
        : false;

    return (
        <Accordion.Item
            id={`financial-details-${contractId}`}
            title={isSMECustomer ? t('title.sme') : t('title.private')}
            titleLevel={4}
            contentClassName={'u-pr-none'}
        >
            <div>
                <GeneralSection
                    details={financialDetails}
                    isActive={isActive}
                    productType={productTypeEN}
                    isSMECustomer={isSMECustomer}
                />
                <CollectionDateSection
                    details={financialDetails}
                    isActive={isActive}
                    contractId={contractId}
                    isContactInformationChangePending={isContactInformationChangePending}
                    isSMECustomer={isSMECustomer}
                    isVDLContract={isVDLContract(contract)}
                    setShowSuccessNotification={setShowSuccessNotification}
                />
                <IbanSection
                    details={financialDetails}
                    isActive={isActive}
                    contractId={contractId}
                    userEmail={myProfileData?.contactDetails?.email || ''}
                    isContactInformationChangePending={isContactInformationChangePending}
                    setShowSuccessNotification={setShowSuccessNotification}
                />
                <PaymentSection
                    details={financialDetails}
                    isActive={isActive}
                    productType={productType}
                    isSMECustomer={isSMECustomer}
                    contract={contract}
                />
            </div>
        </Accordion.Item>
    );
};
